/* @flow */

import clsx from 'clsx';
import React, { useCallback } from 'react';

import './RowSetting.css';
import { logError } from '../../helpers/debug/debug';
import AccessibleButton from '../buttons/AccessibleButton';
import { PictoArrowRight } from '../pictos/Element';
import Picto from '../pictos/Picto';

type RowSettingActionPropType = {
  +'aria-label'?: string,
  +ActionPicto?: React.ComponentType<{ ...React.ElementConfig<typeof Picto>, children?: React.Node }>,
  +children: React.Node,
  +className?: string,
  +data?: any,
  +isDisabled?: boolean,
  +onClick?: (data: any) => Promise<void> | void,
};

const RowSettingAction = (rowSettingActionProps: RowSettingActionPropType): React.Node => {
  const { ActionPicto = PictoArrowRight, 'aria-label': ariaLabel, children, className = '', data, isDisabled = false, onClick } = rowSettingActionProps;

  const executionAction = useCallback(() => {
    const result = onClick?.(data);

    if (result instanceof Promise) {
      result.catch((error) => {
        logError(`Error in RowSettingAction onClick: ${error.message}`);
      });
    }
  }, [data, onClick]);

  const handleOnClick = useCallback(() => executionAction(), [executionAction]);

  return (
    <AccessibleButton aria-label={ariaLabel} className={clsx('rowSetting', className, isDisabled && 'disabled')} onClick={!isDisabled ? handleOnClick : undefined}>
      <div className='rowSettingLabel'>{children}</div>
      <ActionPicto aria-hidden defaultAriaLabelKey='accessibility.picto.arrow_right' forceHoverEffect={!isDisabled} />
    </AccessibleButton>
  );
};

export default RowSettingAction;
